// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Help-module_link_button_eZZFe {
  font-size: 22px;
}

.Help-module_email_link_button__SOg9 {
  padding-left: 34px;
}

.Help-module_help_card_WkO58 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.Help-module_help_box_R57bG {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 12px;
}

.Help-module_more_help_header_hiSyZ {
  font-size: 26px;
  font-weight: 600;
  color: var(--uu-text);
}

.Help-module_help_info_text_syLHY {
  display: flex;
  font-size: large;
  color: var(--uu-text-lighter);
}

.Help-module_questions_box_sdV2G {
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/Help.module.css"],"names":[],"mappings":"AAAA;EAEE,eAAe;AACjB;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".link_button {\n  composes: bos_external_link from 'Styles/styles.module.css';\n  font-size: 22px;\n}\n\n.email_link_button {\n  composes: bos_link from 'Styles/styles.module.css';\n  padding-left: 34px;\n}\n\n.help_card {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.help_box {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-left: 12px;\n}\n\n.more_help_header {\n  font-size: 26px;\n  font-weight: 600;\n  color: var(--uu-text);\n}\n\n.help_info_text {\n  display: flex;\n  font-size: large;\n  color: var(--uu-text-lighter);\n}\n\n.questions_box {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link_button": `Help-module_link_button_eZZFe ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_external_link"]}`,
	"email_link_button": `Help-module_email_link_button__SOg9 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_link"]}`,
	"help_card": `Help-module_help_card_WkO58`,
	"help_box": `Help-module_help_box_R57bG`,
	"more_help_header": `Help-module_more_help_header_hiSyZ`,
	"help_info_text": `Help-module_help_info_text_syLHY`,
	"questions_box": `Help-module_questions_box_sdV2G`
};
export default ___CSS_LOADER_EXPORT___;
